import { Link } from "react-router-dom";
import { Instagram, MapPin, Phone, ArrowUpRight } from "lucide-react";
import { STUDIO, HOURS, NAV } from "../../data/site";
import { Marquee } from "./Marquee";

export function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-ash bg-obsidian">
      {/* marquee band */}
      <Link to="/booking" className="block border-b border-ash py-8 group">
        <Marquee duration={26}>
          {["Book Now", "Where Precision Meets Prestige", "Custom Tattoos", "Springfield VA"].map((t, i) => (
            <span key={i} className="display text-5xl sm:text-7xl text-stroke group-hover:[-webkit-text-stroke-color:#A855F7] transition-all px-8 flex items-center gap-8">
              {t} <span className="text-violet not-italic" style={{ WebkitTextStroke: "0" }}>✦</span>
            </span>
          ))}
        </Marquee>
      </Link>

      <div className="max-w-[1700px] mx-auto px-5 sm:px-8 lg:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <h3 className="display text-5xl md:text-6xl text-white leading-[0.9]">Let's make<br />something<br /><span className="text-violet">permanent.</span></h3>
            <Link to="/booking" data-testid="footer-book-button" className="group inline-flex items-center gap-2 mt-8 font-mono text-[0.7rem] uppercase tracking-[0.2em] font-bold bg-violet text-obsidian px-8 py-4 rounded-full hover:bg-white transition-colors">
              Book a Session <ArrowUpRight size={15} className="group-hover:rotate-45 transition-transform" />
            </Link>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow mb-5">Contact</p>
            <ul className="space-y-4 text-[#C4C4CC] text-sm">
              <li className="flex gap-3"><MapPin size={16} className="text-violet shrink-0 mt-0.5" /><span>{STUDIO.address}<br />{STUDIO.cityStateZip}</span></li>
              <li className="flex gap-3"><Phone size={16} className="text-violet shrink-0" /><a href={STUDIO.phoneHref} className="link-underline">{STUDIO.phone}</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="eyebrow mb-5">Hours</p>
            <ul className="space-y-3 text-sm">
              {HOURS.map((h) => (
                <li key={h.day} className="flex flex-col">
                  <span className="text-white">{h.day}</span>
                  <span className="text-[#828290] font-mono text-xs">{h.time}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="eyebrow mb-5">Explore</p>
            <ul className="space-y-3 text-sm text-[#C4C4CC]">
              {NAV.map((n) => <li key={n.to}><Link to={n.to} className="link-underline">{n.label}</Link></li>)}
              <li><Link to="/aftercare" className="link-underline">Aftercare</Link></li>
              <li><Link to="/faq" className="link-underline">FAQ</Link></li>
            </ul>
            <a href={STUDIO.instagram} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 mt-6 text-[#828290] hover:text-violet transition-colors"><Instagram size={18} /></a>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-ash flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-[#828290] font-mono uppercase tracking-widest">
          <span>© {new Date().getFullYear()} Obsidian Ink Studio</span>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-white">Privacy</Link>
            <Link to="/terms" className="hover:text-white">Terms</Link>
            <Link to="/policies" className="hover:text-white">Policies</Link>
            <Link to="/aftercare" className="hover:text-white">Aftercare</Link>
            <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-violet">Studio Login</Link>
          </div>
        </div>

        <div className="mt-6 text-center text-[0.65rem] text-[#6b6b78] font-mono uppercase tracking-widest" data-testid="footer-credit">
          Website built &amp; SEO by <a href="https://webnehtech.com" target="_blank" rel="noreferrer" className="text-[#828290] hover:text-violet transition-colors">webnehtech.com</a>
        </div>
      </div>
    </footer>
  );
}
